// extracted by mini-css-extract-plugin
var _1 = "_u6A0H";
var _2 = "_zH5N9";
var _3 = "_jF89b";
var _4 = "_P5LPt";
var _5 = "_ecX6V";
export { _1 as "forbiddenPage", _2 as "link", _3 as "messageContainer", _4 as "subtitle", _5 as "title" }
